import { render, staticRenderFns } from "./Tache.vue?vue&type=template&id=02856fd1&"
import script from "./Tache.vue?vue&type=script&lang=ts&"
export * from "./Tache.vue?vue&type=script&lang=ts&"
import style0 from "./Tache.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports